import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import ModalEventBus, { IModal } from 'Events/ModalEventBus';
import ComponentEventBus, { IComponentWrapper, Events as ComponentWrapperEvents } from 'Events/ComponentWrapperEventBus';


@Component({
    template: '#modal-component-template',
    //name: 'delivery-address'
})
export default class ModalComponent extends Vue {


    private selectedId: string = null;
    private isAccepted: boolean = false;
    private error: boolean = false;

    @Prop()
    public uniqueId: string;

    public obj: IModal = <any>{};

    private modalToggleBtn: HTMLButtonElement;

    mounted() {

        this.modalToggleBtn = <HTMLButtonElement>document.getElementById('modalBtn'+this.uniqueId);

        var self = this;
        ModalEventBus.$on('show-modal', (value: any) => {
            self.isAccepted = false;
            self.selectedId = value;
            self.toggle(self);
            self.obj = value;
            self.obj.currentComponent = self;
        });
    }

    // mounted() {
    //     //console.log(this.$refs);

    // }

    emitAccept(e:Event,obj: any) {
        this.selectedId = null;
        this.toggle(this);
        this.$emit('confirm-accept', obj);
        ComponentEventBus.$emit(ComponentWrapperEvents.REMOVE, {type: 'modal-text-component', instance: this});
    }

    emitCancel(e: Event, obj: any) {
        this.toggle(this);
        this.selectedId = null;
        this.$emit('confirm-cancel', e,obj);
        ComponentEventBus.$emit(ComponentWrapperEvents.REMOVE, {type: 'modal-text-component', instance: this});
    }

    toggle(self: any) {
        self.modalToggleBtn.click();
    }
}

Vue.component('modal-component', ModalComponent);